module.exports = __webpack_public_path__ + "./images/d1968299c3b4e12452cf41588442dafd.webp";